import { connect } from 'react-redux';
import { compose, lifecycle, withStateHandlers, withHandlers } from 'recompose';

import config from 'config';
import { updateUser } from 'modules/session/actions/updateUser';
import { getSessionInfo } from 'modules/session/actions/getSessionInfo';
import { sessionInitialized } from 'modules/appointmentsManagement/selectors/contracts';
import { fetchOrganizationLogo } from 'modules/auth/actions/fetchOrganizationLogo';
import { checkExternalInitialization } from 'shared/utils/externalLoginUtils';
import isMobile from 'shared/utils/checkMobileDevice';
import { replaceTo } from 'modules/auth/actions/redirectAction';
import { addToast } from 'modules/messageSystem/actions/addToast';

import CreateAppointmentPage from './CreateAppointmentPage';

const mapStateToProps = (state) => ({
  sessionRequestStatus: state.session.sessionInfo.requestStatus,
  sessionInitialized: sessionInitialized(state),
  isExternalInit: checkExternalInitialization(),
});

export default compose(
  connect(
    mapStateToProps,
    {
      updateUser,
      getSessionInfo,
      fetchOrganizationLogo,
      addToast,
    },
  ),

  withStateHandlers({ screenHeight: '100%' }, {
    setMobileState: () => () => ({ screenHeight: document.getElementById('rootPage').clientHeight }),
  }),

  withHandlers({
    handleMessage: ({ isExternalInit, addToast }) => (event) => {
      if (!event.data || typeof event.data !== 'string' || event.origin !== config.web_cac_link) return;

      const data = JSON.parse(event.data);

      if (data.action === 'appointment-cancel') {
        if (isExternalInit) {
          replaceTo('/appointment/create/cancel');
        } else {
          replaceTo('/appointments?list=true');
        }
      }

      if (data.action === 'appointment-created') {
        if (isExternalInit) {
          replaceTo('/appointment/create/success');
        } else {
          replaceTo('/appointments?list=true');
          addToast('success', 'appt-create-success', {
            id: 'Patient.Appointment.Create.SuccessMessage.Snackbar',
            defaultMessage: '** Appointment created successfully',
          });
        }
      }

      if (data.action === 'appointment-messaging-created') {
        if (isExternalInit) {
          replaceTo(`/appointment/create/success-messaging/${ data.payload.appointmentId }`);
        } else {
          replaceTo('/appointments?list=true');
          addToast('success', 'appt-create-success', {
            id: 'Patient.Appointment.Create.SuccessMessage.Snackbar',
            defaultMessage: '** Appointment created successfully',
          });
        }
      }
    },
  }),

  lifecycle({
    componentDidMount() {
      const {
        isExternalInit,
        sessionInitialized,
        getSessionInfo,
        updateUser,
        location: { search: searchParams },
        setMobileState,
        fetchOrganizationLogo,
      } = this.props;
      window.addEventListener('message', this.props.handleMessage);
      if (!isExternalInit) return;

      if (isMobile()) setMobileState();

      const params = new URLSearchParams(searchParams);
      const token = params.get('token');
      if (token) localStorage.setItem('jwt', token);

      if (sessionInitialized && !token) return;

      getSessionInfo()
        .then(({ payload: { selectedOrganizationToken } }) => fetchOrganizationLogo(selectedOrganizationToken))
        .then(updateUser)
        .catch(() => {});
    },
    componentWillUnmount() {
      window.removeEventListener('message', this.props.handleMessage);
    },
  }),
)(CreateAppointmentPage);
